'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutCategory = void 0;
var TimeoutCategory;
(function (TimeoutCategory) {
    TimeoutCategory[TimeoutCategory["ONE_DAY"] = 1] = "ONE_DAY";
    TimeoutCategory[TimeoutCategory["ONE_WEEK"] = 2] = "ONE_WEEK";
    TimeoutCategory[TimeoutCategory["ONE_MONTH"] = 3] = "ONE_MONTH";
})(TimeoutCategory = exports.TimeoutCategory || (exports.TimeoutCategory = {}));
